import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "catalog-page"
};
const _hoisted_2 = {
  class: "exo"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No matches; please broaden your search.", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_box = _resolveComponent("filter-box");
  const _component_el_col = _resolveComponent("el-col");
  const _component_publication_table = _resolveComponent("publication-table");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      md: 6,
      sm: 24,
      xs: 24,
      class: "filter-box-container"
    }, {
      default: _withCtx(() => [_createVNode(_component_filter_box, {
        title: "filters",
        "onUpdate:modelValue": _ctx.updateFilters,
        onClear: _ctx.resetFilter,
        modelValue: _ctx.editFilters,
        "allow-country-selection": true,
        "allow-publisher-selection": true,
        "blank-filters": _ctx.blankFilters
      }, null, 8, ["onUpdate:modelValue", "onClear", "modelValue", "blank-filters"])]),
      _: 1
    }), _ctx.hasCounts ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      md: 18,
      sm: 24,
      xs: 24
    }, {
      default: _withCtx(() => [_createElementVNode("h3", _hoisted_2, [_createElementVNode("span", null, [_createElementVNode("em", null, _toDisplayString(_ctx.matchCounts?.products.toLocaleString()), 1), _createTextVNode(" matches in "), _createElementVNode("em", null, _toDisplayString(_ctx.matchCounts?.publications.toLocaleString()), 1), _createTextVNode(" series ")])]), _createVNode(_component_publication_table, {
        columns: _ctx.columns,
        filters: _ctx.filters,
        total: _ctx.matchCounts.publications
      }, null, 8, ["columns", "filters", "total"])]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_col, {
      key: 1,
      md: 18,
      sm: 24,
      xs: 24
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }))]),
    _: 1
  })]);
}